import { useMemo } from 'react';
import { getClipTotalDurationInFrames } from '../../utils/configUtils';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import { roundToNDecimalPlaces } from '@/libs/utils';

export default function useRemotionPlayerDuration() {
  const { clipData, fps } = useClipsContext();

  const playerDuration = useMemo(() => {
    const totalDurationInFrames = getClipTotalDurationInFrames(clipData);
    return roundToNDecimalPlaces(totalDurationInFrames / fps, 3);
  }, [clipData, fps]);

  return playerDuration;
}
